/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UserResponse } from '../../models/user-response';

export interface UserRoleControllerGetUsers$Params {
  limit: number;
  skip: number;
  id: number;
}

export function userRoleControllerGetUsers(http: HttpClient, rootUrl: string, params: UserRoleControllerGetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, userRoleControllerGetUsers.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UserResponse;
      }>;
    })
  );
}

userRoleControllerGetUsers.PATH = '/user-role/{id}/users';
